import { useContext, useEffect } from "react"
import Toast from "react-bootstrap/Toast"
import VicinityContext from "../context/vicinityContext"
import { consoleLog } from "../utilities/helpers"

export function ToastNoPlace() {
    let showToast = useContext(VicinityContext).showToast
    let setShowToast = useContext(VicinityContext).setShowToast
    let toastMessage = useContext(VicinityContext).toastMessage
    let toastOptions = useContext(VicinityContext).toastOptions
    let setToastOptions = useContext(VicinityContext).setToastOptions

    useEffect(() => {
        if (!toastOptions.icon) {
            setToastOptions({ ...toastOptions, icon: "grow" })
        }
    }, [toastMessage, toastOptions, setToastOptions])

    return (
        <div
            style={{
                position: "fixed",
                top: 20,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 9999,
            }}
        >
            <Toast
                onClose={() => setShowToast(false)}
                onExit={() => consoleLog("Toast auto closed")}
                bg="dark"
                show={showToast}
                delay={10000}
                autohide
            >
                <Toast.Header>
                    <i className="bi bi-bell pe-2"></i>
                    <strong className="me-auto">Notification</strong>
                    <small>
                        <div
                            className={`spinner-${toastOptions.icon} spinner-${toastOptions.icon}-sm text-dark`}
                            role="status"
                        >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </small>
                </Toast.Header>
                <Toast.Body className="text-white">
                    {`${toastMessage}`}
                </Toast.Body>
            </Toast>
        </div>
    )
}
